import { TSpacing } from './theme.types';

const spacing: TSpacing = {
  none: '0',
  xxs: '0.125rem', // 2px
  xs: '0.25rem', // 4px
  s: '0.5rem', // 8px
  sm: '0.75rem', // 12px
  m: '1rem', // 16px
  ml: '1.25rem', // 20px
  l: '1.5rem', // 24px
  xl: '2rem', // 32px
  xxl: '2.5rem', // 40px
};

export default spacing;
